export default __webpack_public_path__ + "static/Upbit_logo-8583cbab65c46153513d2216d80d3003.png";